"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _system = require("@/api/system");
var _permission = require("@/utils/permission");
var _lifeVibesPoint = require("@/api/lifeVibesPoint");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LifeVibesPointList',
  data: function data() {
    return {
      listLoading: false,
      detailLoading: false,
      detailDrawerVisible: false,
      currentDetail: null,
      tableHeight: 0,
      regionOptions: [],
      selectedRegion: [],
      searchForm: {
        keywords: '',
        pointType: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        lng: '',
        lat: '',
        maxDistance: ''
      },
      tableFrom: {
        page: 1,
        limit: 10,
        keywords: '',
        pointType: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        lng: '',
        lat: '',
        maxDistance: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      regionProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        emitPath: true,
        checkStrictly: false
      },
      pointTypeOptions: [{
        label: '集市',
        value: 0
      }, {
        label: '展会地点',
        value: 1
      }, {
        label: '预留',
        value: 2
      }, {
        label: '打野地点',
        value: 3
      }]
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:lifeVibesPoint:list'])) {
      this.loadRegionData();
      this.getList();
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.calculateTableHeight();
    });
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    loadRegionData: function loadRegionData() {
      var _this2 = this;
      (0, _system.cityListApi)().then(function (res) {
        _this2.regionOptions = res || [];
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _lifeVibesPoint.lifeVibesPointList)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list || [];
        _this3.tableData.total = res.total || 0;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.tableData.data = [];
        _this3.tableData.total = 0;
        _this3.listLoading = false;
      });
    },
    handleRegionChange: function handleRegionChange(values) {
      var _this4 = this;
      var regionCodes = (values || []).map(function (item) {
        return _this4.extractRegionCode(item);
      });
      this.searchForm.provinceCode = regionCodes[0] || '';
      this.searchForm.cityCode = regionCodes[1] || '';
      this.searchForm.districtCode = regionCodes[2] || '';
    },
    handleSearch: function handleSearch() {
      this.tableFrom.page = 1;
      this.tableFrom.keywords = this.searchForm.keywords;
      this.tableFrom.pointType = this.searchForm.pointType;
      this.tableFrom.provinceCode = this.searchForm.provinceCode;
      this.tableFrom.cityCode = this.searchForm.cityCode;
      this.tableFrom.districtCode = this.searchForm.districtCode;
      this.tableFrom.lng = this.searchForm.lng;
      this.tableFrom.lat = this.searchForm.lat;
      this.tableFrom.maxDistance = this.searchForm.maxDistance;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        keywords: '',
        pointType: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        lng: '',
        lat: '',
        maxDistance: ''
      };
      this.selectedRegion = [];
      this.tableFrom = {
        page: 1,
        limit: this.tableFrom.limit,
        keywords: '',
        pointType: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        lng: '',
        lat: '',
        maxDistance: ''
      };
      this.getList();
    },
    handleAdd: function handleAdd() {
      this.$router.push({
        path: '/market/life-vibes-point/form'
      });
    },
    handleEdit: function handleEdit(row) {
      var query = {
        id: row.id
      };
      this.$router.push({
        path: '/market/life-vibes-point/form',
        query: query
      });
    },
    handleDetail: function handleDetail(row) {
      var _this5 = this;
      this.detailDrawerVisible = true;
      this.detailLoading = true;
      this.currentDetail = null;
      (0, _lifeVibesPoint.lifeVibesPointInfo)(row.id).then(function (res) {
        _this5.currentDetail = res;
        _this5.detailLoading = false;
      }).catch(function () {
        _this5.detailLoading = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$modal.confirm("\u786E\u8BA4\u5220\u9664\u70B9\u4F4D\u201C".concat(row.pointName || row.id, "\u201D\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\u3002")).then(function () {
        (0, _lifeVibesPoint.lifeVibesPointDelete)(row.id).then(function () {
          _this6.$message.success('删除成功');
          _this6.getList();
        });
      }).catch(function () {});
    },
    handleDetailClose: function handleDetailClose() {
      this.detailDrawerVisible = false;
      this.currentDetail = null;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.tableFrom.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.getList();
    },
    calculateTableHeight: function calculateTableHeight() {
      var _this7 = this;
      this.$nextTick(function () {
        var windowHeight = window.innerHeight;
        var headerHeight = _this7.$refs.tableheader ? _this7.$refs.tableheader.offsetHeight : 0;
        var paginationHeight = 60;
        var otherHeight = 200;
        _this7.tableHeight = windowHeight - headerHeight - paginationHeight - otherHeight;
      });
    },
    getImageList: function getImageList(imageValue) {
      if (!imageValue) return [];
      if (Array.isArray(imageValue)) return imageValue.filter(Boolean);
      if (typeof imageValue === 'string') {
        try {
          var parsed = JSON.parse(imageValue);
          if (Array.isArray(parsed)) return parsed.filter(Boolean);
        } catch (error) {
          var commaList = imageValue.split(',').map(function (item) {
            return item.trim();
          }).filter(Boolean);
          if (commaList.length > 1) return commaList;
        }
        return [imageValue];
      }
      return [];
    },
    getFirstImage: function getFirstImage(imageValue) {
      var images = this.getImageList(imageValue);
      return images.length ? images[0] : '';
    },
    resolveTags: function resolveTags(tags) {
      if (!tags) return [];
      return String(tags).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    },
    formatRegion: function formatRegion(row) {
      var regions = [row.province, row.city, row.district].filter(Boolean);
      return regions.filter(function (item, index) {
        return item !== regions[index - 1];
      }).join(' ');
    },
    hasValue: function hasValue(value) {
      return value !== null && value !== undefined && value !== '';
    },
    extractRegionCode: function extractRegionCode(code) {
      if (!this.hasValue(code)) return '';
      var match = String(code).match(/(\d{6})$/);
      return match ? Number(match[1]) : Number(code);
    },
    isCertified: function isCertified(status) {
      return Number(status) > 0;
    },
    getLinkedMarketId: function getLinkedMarketId(row) {
      if (row && row.marketId) return row.marketId;
      var status = Number(row && row.merchantStatus);
      if (row && Number(row.pointType) === 0 && status > 1) return status;
      return '';
    },
    getPointTypeText: function getPointTypeText(type) {
      var textMap = {
        0: '集市',
        1: '展会地点',
        2: '预留',
        3: '打野地点'
      };
      return textMap[type] || '未知';
    },
    getPointTypeTagType: function getPointTypeTagType(type) {
      var typeMap = {
        0: 'success',
        1: 'warning',
        2: 'info',
        3: 'danger'
      };
      return typeMap[type] || 'info';
    }
  }
};